var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9964315,14.5358925 L11.5261586,10.1069796 C12.4268852,8.8415759 12.8939287,7.2431713 12.6604069,5.54486632 C12.260084,2.68105799 9.9248668,0.4166514 7.0225255,0.15025063 C3.08601659,-0.24935053 -0.25000792,3.08065915 0.15031502,7.0433707 C0.41719698,9.907179 2.68569365,12.2714859 5.55467473,12.671087 C7.2560472,12.9041877 8.857339,12.4379864 10.1250283,11.5388837 L14.5619409,15.9677966 C14.7621024,16.1675972 15.0623446,16.1675972 15.2625061,15.9677966 L15.9630712,15.2684946 C16.1632327,15.068694 16.1632327,14.735693 15.9964315,14.5358925 L15.9964315,14.5358925 Z M2.11856948,6.4106688 C2.11856948,4.04636196 4.0534637,2.11495634 6.4220411,2.11495634 C8.7906185,2.11495634 10.7255127,4.04636196 10.7255127,6.4106688 C10.7255127,8.7749757 8.7906185,10.7063813 6.4220411,10.7063813 C4.0534637,10.7063813 2.11856948,8.8082758 2.11856948,6.4106688 L2.11856948,6.4106688 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    id: "Rectangle-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#6D6D6D",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "-1 0 16 0 17 16 0 17"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.b99bef34aac2fa57ab571d51d8a4581b.svg";
export { ForwardRef as ReactComponent };